export const ROLES = {
  ADMIN: 'admin',
  SENIOR_ACCOUNTANT: 'senior_accountant',
  ORDER_PROCESSOR: 'order_processor',
  DELIVERY_COORDINATOR: 'delivery_coordinator',
  KNITS_MANAGER: 'knits_manager',
  WOVEN_MANAGER: 'woven_manager',
  VIEWER: 'viewer',
};

const PAGE_ACCESS = {
  '/dashboard':          ['admin', 'senior_accountant', 'knits_manager', 'woven_manager', 'viewer'],
  '/finance':            ['admin', 'senior_accountant', 'viewer'],
  '/clients-suppliers':  ['admin', 'senior_accountant', 'viewer'],
  '/inventory':          ['admin', 'senior_accountant', 'order_processor', 'knits_manager', 'woven_manager', 'viewer'],
  '/invoicing':          ['admin', 'senior_accountant', 'delivery_coordinator', 'viewer'],
  '/hrm':                ['admin', 'senior_accountant', 'knits_manager', 'woven_manager', 'viewer'],
  '/outsourcing':        ['admin', 'senior_accountant', 'viewer'],
  '/reports':            ['admin', 'senior_accountant', 'viewer'],
  '/settings':           ['admin'],
};

export const canAccessPage = (role, path) => {
  if (!role || !path) return false;
  const basePath = '/' + path.split('/')[1];
  return PAGE_ACCESS[basePath]?.includes(role) ?? false;
};

export const getDefaultRedirect = (role) => {
  if (role === 'order_processor') return '/inventory';
  if (role === 'delivery_coordinator') return '/invoicing';
  if (role === 'knits_manager' || role === 'woven_manager') return '/inventory';
  return '/dashboard';
};

export const canDelete = (role) => role === 'admin';
export const canWrite = (role) => !['viewer', 'knits_manager', 'woven_manager'].includes(role);
export const canSeePrice = (role) => !['order_processor', 'knits_manager', 'woven_manager'].includes(role);
export const canEditOrder = (role) => ['admin', 'senior_accountant'].includes(role);
export const canAccessInvoicesTab = (role) => role !== 'delivery_coordinator';
export const getLineFilter = (role) => {
  if (role === 'knits_manager') return 'knits';
  if (role === 'woven_manager') return 'woven';
  return null;
};
